<div class="event-card-skeleton"
     *ngIf="mode() === 'horizontal'">

  <div class="skeleton-img shimmer"></div>

  <div class="skeleton-body">
    <div class="skeleton-line line--title shimmer"></div>

    <div class="skeleton-line line--text shimmer"></div>
    <div class="skeleton-line line--text short shimmer"></div>

    <div class="d-flex ion-justify-content-between ion-align-items-center mt-sm">
      <div class="skeleton-chip shimmer"></div>
      <div class="skeleton-likes shimmer"></div>
    </div>
  </div>

</div>
